if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        gridContainer: ".m-mixed-layout__wrapper",
        swiperWrapper: ".swiper-wrapper",
        slideControls: ".m-slider-controls",
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.useScrollMobile = this.dataset.useScrollMobile === "true";
      this.itemsPerPage = this.dataset.itemsPerPage || this.dataset.productsPerRow;
      this.paginationType = "bullets";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          this.products = recommendations.querySelectorAll(".m-product-card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            MinimogTheme.CompareProduct?.setCompareButtonsState();
            MinimogTheme.Wishlist?.setWishlistButtonsState();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
      const isMobile = window.innerWidth < 768 || (MinimogTheme && MinimogTheme.config && MinimogTheme.config.mqlMobile);

      if (isMobile) {
        this.initSlider();
        if (!this.useScrollMobile) return;
        gridContainer && gridContainer.classList.remove("swiper-container");
        slideControls && slideControls.classList.add("m:hidden");
        if (this.swiper) this.swiper.destroy(false, true);
        gridContainer && gridContainer.parentNode.classList.add("m-mixed-layout--mobile-scroll");
      } else {
        gridContainer && gridContainer.classList.add("swiper-container");
        gridContainer && gridContainer.parentNode.classList.remove("m-mixed-layout--mobile-scroll");
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() { 
      let __this = this;
      const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
      const items = parseInt(this.itemsPerPage) || 4;
      const isMobile = window.innerWidth < 768 || (MinimogTheme && MinimogTheme.config && MinimogTheme.config.mqlMobile);
      const limit = isMobile ? 1.5 : items;

      if (this.enableSlider && this.products > limit) {
        this.slider = new MinimogLibs.Swiper(gridContainer, {
          slidesPerView: 1.5,
          loop: false,
          slidesOffsetBefore: 0,
          autoplay: false,
          centeredSlides: false,
          pagination: this.querySelector(".swiper-pagination")
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                type: this.paginationType,
              }
            : false,
          threshold: 2,
          breakpoints: {
            768: {
              slidesPerView: items >= 3 ? 3 : items,
            },
            1024: {
              slidesPerView: items >= 4 ? 4 : items,
            },
            1280: {
              slidesPerView: items == 4 ? 4.5 : (items >= 4 ? 4.5 : items),
            }
          },
          on: {
            init: function () {
              setTimeout(() => { 
                const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
                const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
                const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
                if (firstItem && slideControls) {
                  const itemHeight = firstItem.clientHeight;
                  slideControls.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                  prevButton.classList.remove("m:hidden");
                  nextButton.classList.remove("m:hidden");
                }
              }, 200);
            },
          },
        });

        if (this.slider) {
          slideControls && slideControls.classList.remove("m:hidden");
          const prevBtn = this.querySelector(".m-slider-controls__button-prev");
          const nextBtn = this.querySelector(".m-slider-controls__button-next");
          prevBtn && prevBtn.addEventListener("click", () => this.slider.slidePrev());
          nextBtn && nextBtn.addEventListener("click", () => this.slider.slideNext());
        }

        this.swiper = gridContainer?.swiper;
      } else {
        const innerContainer = gridContainer.querySelector(".m-mixed-layout__inner");
        innerContainer && innerContainer.classList.remove("swiper-wrapper");
        innerContainer && innerContainer.classList.add("m:grid");
        slideControls && slideControls.classList.add("m:hidden");
        gridContainer && gridContainer.classList.remove("swiper-container");
      }
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
